import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { DropdownOption } from 'shared-client/types/fields';
import { DropdownProps, FormDropdown } from '.';

export type YearDropdownProps = FieldRenderProps<any, HTMLInputElement> &
	DropdownProps & {
		startYear?: number;
		numberOfYears?: number;
	};

/**
 * Component that renders a dropdown with years.
 *
 * @class YearDropdown
 * @extends {React.Component<YearDropdownProps>}
 */
class YearDropdown extends React.Component<YearDropdownProps> {
	private options: DropdownOption[] = [];

	public static defaultProps: Partial<YearDropdownProps> = {
		startYear: new Date().getFullYear(),
		numberOfYears: 10,
	};

	constructor(props) {
		super(props);

		const { startYear, numberOfYears } = props;

		for (let i = 0; i < numberOfYears; i++) {
			this.options.push({
				value: `${startYear + i}`,
				text: `${startYear + i}`,
			});
		}
	}

	public render() {
		// eslint-disable-next-line no-unused-vars
		const { startYear, numberOfYears, ...rest } = this.props;

		return <FormDropdown {...rest} addSelectOption options={this.options} />;
	}
}

export default YearDropdown;
